/* eslint-disable react-hooks/exhaustive-deps */
import { useAuthState } from '@core/configureStore';
import { useHeroApiService } from '@core/hooks';
import { SocialPost } from '@core/models';
import { useEffect, useMemo, useState } from 'react';

export const useSocialPosts = () => {
  const heroApiService = useHeroApiService();
  const { user } = useAuthState();
  const [socialPosts, setSocialPosts] = useState<SocialPost[]>([]);
  const locationId = useMemo(() => user?.selected_location.location_id, [user]);

  useEffect(() => {
    const init = async () => {
      if (!locationId) return;
      const socialPosts = await heroApiService.getLocationSocialPosts(locationId);
      setSocialPosts(socialPosts);
    };
    init();
  }, [locationId]);

  return {
    socialPosts,
    setSocialPosts,
  };
};
